<div class="app-ic-search "
  [ngStyle]="{'background-color': settingsData.bg_secondary_color ? settingsData.bg_secondary_color : null,'font-family': settingsData.font_family ? settingsData.font_family : null  }">
  <div class="p-100-50 res-padding">
    <span (click)="goBack()" class="pointer" 
      [ngStyle]="{
        'color': settingsData?.font_primary_color, 
        'font-size': settingsData?.subs_fs_sub_title 
      }">
      <i [ngStyle]="{
        'color': settingsData?.font_primary_color, 
        'font-size': settingsData?.subs_fs_sub_title
      }"
        class="fa fa-angle-left"></i>
      <div
        [ngStyle]="{
          'color': settingsData?.font_primary_color, 
          'font-family': settingsData?.font_family,
          'font-size': settingsData?.subs_fs_sub_title
        }"
        class="ml-5 d-none d-md-inline-block">Back</div>
    </span>
    <div class="row no-gutters w-100">
      <div class="col-12 text-right">
        <div class="dropdown" *ngIf="!noRec">
          <button class="btn btn-secondary filterBtn" type="button" id="dropdownMenuButton" (click)="openIcon()"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            [ngStyle]="{
              'background-color': settingsData?.bg_primary_color,
              'color': settingsData?.font_primary_color,
              'font-family': settingsData?.font_family,
              'line-height': '1',
              'border-radius': '8px'
            }"
            >
            <span class="text-capitalize align-middle"> Filter
            </span><span class="align-middle ml-15"><i class="fa fa-filter"></i></span>
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
          [ngStyle]="{
            'background-color': settingsData?.bg_primary_color,
            'color': settingsData?.font_primary_color ,
            'font-family': settingsData?.font_family
          }"
          >
            <a class="dropdown-item text-right" *ngIf="selectedVal?.artist || selectedVal?.genre || selectedVal?.mode"
              (click)="filterSearchResult('all')"
              [ngStyle]="{
                'color': settingsData?.font_primary_color,
                'font-family': settingsData?.font_family
              }"
              >Clear Filters</a>
            <a class="f-heading c-default"
            [ngStyle]="{
              'background-color' :settingsData?.bg_secondary_color,
              'color': settingsData?.font_primary_color,
              'font-family': settingsData?.font_family
            }"
            >Artist</a>
            <a class="dropdown-item pl-30" *ngFor="let artist of artistList;let i=index">
              <mat-checkbox name="artist" (change)="changeVal($event,i,'artist')" class="fw-300"
                [(ngModel)]="artist.isChecked"
                [ngClass]="{
                  'custom-channel-checkbox-border': settingsData?.font_primary_color,  
                  'custom-channel-checkbox-background' : settingsData?.font_primary_color
                }"
                [ngStyle]="
                {
                  '--custom-channel-checkbox-border-color': settingsData.font_primary_color,
                  '--custom-channel-checkbox-background-color' : settingsData?.font_primary_color                  
                }"
                >
              </mat-checkbox>
              <span class="c-default" *ngIf="artist.key.length <= 15"
                [ngClass]="{'text-info':selectedVal?.artist == artist.key}"
                [ngStyle]="{
                  'color': settingsData?.font_primary_color,
                  'font-family': settingsData?.font_family
                }"
                >
                {{artist.key}}({{artist.doc_count}})
              </span>
              <span class="c-default" *ngIf="artist.key.length > 15" matTooltipPosition="above"
                matTooltip="{{artist.key}}"
                [ngClass]="{'text-info':selectedVal?.artist == artist.key}"
                [ngStyle]="{
                  'color': settingsData?.font_primary_color,
                  'font-family': settingsData?.font_family
                }"
                >
                {{artist.key | slice:
                0:15}}({{artist.doc_count}})
                {{artist.key.length > 15 ? "..." : ""}}</span>
            </a>
            <a class="f-heading c-default"
            [ngStyle]="{
              'background-color' :settingsData?.bg_secondary_color,
              'color': settingsData?.font_primary_color,
              'font-family': settingsData?.font_family
            }"
            >Genres</a>
            <a class="dropdown-item pl-30" *ngFor="let genre of genresList;let i=index">
              <mat-checkbox name="genre" (change)="changeVal($event,i,'genre')" class="fw-300"
                [(ngModel)]="genre.isChecked"
                [ngClass]="{
                  'custom-channel-checkbox-border': settingsData?.font_primary_color,  
                  'custom-channel-checkbox-background' : settingsData?.font_primary_color
                }"
                [ngStyle]="
                {
                  '--custom-channel-checkbox-border-color': settingsData.font_primary_color,
                  '--custom-channel-checkbox-background-color' : settingsData?.font_primary_color                  
                }"
                >
              </mat-checkbox>
              <span class="c-default" *ngIf="genre.key.length <= 15"
                [ngClass]="{'text-info':selectedVal?.genre == genre.key}"
                [ngStyle]="{
                  'color': settingsData?.font_primary_color,
                  'font-family': settingsData?.font_family
                }">
                {{genre.key}}({{genre.doc_count}})
              </span>
              <span class="c-default" *ngIf="genre.key.length > 15" matTooltipPosition="above"
                matTooltip="{{genre.key}}" [ngClass]="{'text-info':selectedVal?.genre == genre.key}"
                [ngStyle]="{
                  'color': settingsData?.font_primary_color,
                  'font-family': settingsData?.font_family
                }"
                >
                {{genre.key |
                slice: 0:15}}({{genre.doc_count}})
                {{genre.key.length > 15 ? "..." : ""}}</span>
            </a>
            <ng-container *ngIf="streamPaymentModeList.length > 0">
              <a class="f-heading c-default"
              [ngStyle]="{
                'background-color' :settingsData?.bg_secondary_color,
                'color': settingsData?.font_primary_color,
                'font-family': settingsData?.font_family
              }"
              >Payment Mode</a>
              <a class="dropdown-item pl-30" *ngFor="let mode of streamPaymentModeList;let i=index">
                <mat-checkbox name="mode" (change)="changeVal($event,i,'mode')" class="fw-300"
                  [(ngModel)]="mode.isChecked"
                  [ngClass]="{
                    'custom-channel-checkbox-border': settingsData?.font_primary_color,  
                    'custom-channel-checkbox-background' : settingsData?.font_primary_color
                  }"
                  [ngStyle]="
                  {
                    '--custom-channel-checkbox-border-color': settingsData.font_primary_color,
                    '--custom-channel-checkbox-background-color' : settingsData?.font_primary_color                  
                  }"
                  >
                </mat-checkbox>
                <span *ngIf="mode.key.length <= 15" class="text-capitalize c-default"
                  [ngStyle]="{
                    'color': settingsData?.font_primary_color,
                    'font-family': settingsData?.font_family
                  }"
                  [ngClass]="{'text-info':selectedVal?.mode == mode.key}">{{mode.key}}({{mode.doc_count}})</span>
                <span class="c-default" *ngIf="mode.key.length > 15" matTooltipPosition="above"
                  [ngStyle]="{
                    'background-color' :settingsData?.bg_secondary_color,
                    'color': settingsData?.font_primary_color,
                    'font-family': settingsData?.font_family
                  }"
                  matTooltip="{{mode.key}}" [ngClass]="{'text-info':selectedVal?.mode == mode.key}">{{mode.key |
                  slice: 0:15}}({{mode.doc_count}})
                  {{mode.key.length > 15 ? "..." : ""}}
                </span>
              </a>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="gener-types">
      <div class="row no-gutters justify-content-center">
        <ng-container *ngFor="let data of searchData;let i =  index">
          <div class="col-12" *ngIf="data?.data?.length != 0">
            <div class="row align-items-center mb-10 mt-20">
              <div class="col-6">
                <div class="gener-heading" [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null ,
                        'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null,
                        'font-family': settingsData.font_family ? settingsData.font_family : null }">
                  {{data.name}}
                </div>
              </div>
              <!-- <div class="col-6 text-right">
                      <span class="see-all" [ngStyle]="{'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,'font-size': settingsData.fs_sub_title ? settingsData.fs_sub_title : null }"
                        (click)="goToGener(data)">see all</span>
                    </div> -->
            </div>

            <div class="relative">
              <span class="g-previous flex-btns pointer" *ngIf="data?.data?.length>4" (click)="leftScroll(i,data)">
                <i class="fa fa-angle-left text-white"> </i>
              </span>
              <span class="g-next flex-btns pointer" (click)="rightScroll(i,data)" *ngIf="data?.data?.length>4">
                <i class="fa fa-angle-right  text-white"> </i>
              </span>
              <div class="g-container" [id]="'gener'+i">
                <div class="g-image pointer" *ngFor="let xyz of data.data">
                  <div class="a-image br-5" [ngClass]="{'box-radius': settingsData.card_shape == 'round'}"
                    [ngStyle]="{'background-image': 'url('+ xyz.pic +')'}" (click)="goToAlbum(xyz)">
                    <!-- <img src="{{xyz.pic}}" alt=""> -->
                  </div>
                  <!-- <img src='{{xyz.video_thumbnail_image}}' width="100%" (click)="goToAlbum(xyz)"
                          [ngClass]="{'box-radius': settingsData.card_shape == 'round'}"> -->
                  <div class="g-image-info pointer" (click)="goToAlbum(xyz)">
                    <div class="info-title ellipsis w-100" [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null ,
                              'font-size': settingsData.fs_sentence ? settingsData.fs_sentence : null ,
                              'font-family': settingsData.font_family ? settingsData.font_family : null}">
                      {{xyz.type == 'audio' || xyz.type == 'video' ? xyz.stage : xyz.name}}
                    </div>
                    <!-- <div class="date-created" [ngStyle]="{'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
                              'font-size': settingsData.fs_sub_title ? settingsData.fs_sub_title : null ,
                              'font-family': settingsData.font_family ? settingsData.font_family : null }">
                              sdfsdfsdf sdfs dfsdfsdf
                            </div> -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <!-- <section *ngIf="audiosList.length > 0">
            <h3 class="title-primary pb-4 mt-4 mb-0">Audios </h3>
            <div class="row w-100">
                <div class="col-3 relative" *ngFor="let audio of audiosList;let i =  index">
                    <img src="{{audio.pic}}" (click)="goToAlbum(audio)" width="100%" class="br-8 pointer">
                    <h5 class="absolute absolute-pos fw-500 mb-0">{{audio.name}}</h5>
                </div>
            </div>
        </section> -->
    <!-- <section *ngIf="albumsList.length > 0">
            <h3 class="title-primary pb-4 mt-4 mb-0">Albums </h3>
            <div class="row w-100">
                <div class="col-3 relative" *ngFor="let album of albumsList;let i =  index">
                    <img src="{{album.pic}}" (click)="goToAlbum(album)" width="100%" class="br-8 pointer">
                    <h5 class="absolute absolute-pos fw-500 mb-0">{{album.name}}</h5>
                </div>
            </div>
        </section>
        <section *ngIf="videosList.length > 0">
            <h3 class="title-primary pb-4 mt-4 mb-0">Videos </h3>
            <div class="row w-100">
                <div class="col-3 relative" *ngFor="let video of videosList;let i =  index">
                    <img src="{{video.pic}}" (click)="goToAlbum(video)" width="100%" class="br-8 pointer">
                    <h5 class="absolute absolute-pos fw-500 mb-0">{{video.name}}</h5>
                </div>
            </div>
        </section>
        <section *ngIf="videoAlbumList.length > 0">
            <h3 class="title-primary pb-4 mt-4 mb-0">Video Albums </h3>
            <div class="row w-100">
                <div class="col-3 relative" *ngFor="let va of videoAlbumList;let i =  index">
                    <img src="{{va.pic}}" (click)="goToAlbum(va)" width="100%" class="br-8 pointer">
                    <h5 class="absolute absolute-pos fw-500 mb-0">{{va.name}}</h5>
                </div>
            </div>
        </section> -->
    <mat-paginator *ngIf="totalResp > 20" [length]="totalResp" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="filterSearchResult('','','','',$event)"></mat-paginator>
    <ng-container *ngIf="noRec">
      <h1 class="no-rec">{{ searchUnavailable ? 'Search is temporarily unavailable. Please try again shortly.' : 'No records found' }}</h1>
    </ng-container>
  </div>
</div>